import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,Select, MenuItem, Link,
  Paper, Checkbox, Button, Box, Avatar, Typography, useMediaQuery, Card, CardContent, Divider, Chip
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CompanyLogo from '../CompanyLogo'; // assuming you have this

const ResponsiveDecisionMakerList = ({
  decisionMakers,
  selectedDecisionMakers,
  setSelectedDecisionMakers,
  status,
  filterstatus,
  DueDays,
  Project,
  user,
  template,
  templates,
  handlePreview,
  handleStatus,
  ChangeStatus,
  setSelectedDecisionMaker,
  setShowEditSidebar,
  setEmail,
  emails,
  selectedCompany,
  setSelectedCompany
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const filteredDecisionMakers = decisionMakers.filter(dm =>
    filterstatus[status].includes(dm.status) &&
    (selectedCompany === null || selectedCompany.length === 0 || selectedCompany.includes(dm.TargetCompanyId))
  );

  if (isMobile) {
    return (
      <Box display="flex" flexDirection="column" gap={2}>
        {filteredDecisionMakers.map((dm) => {
          const company = Project.TargetCompany.find(tc => tc.Organization === dm.TargetCompanyId);
          const candidate = dm.candidateId;

          // Skip rendering if candidate data is null
          if (!candidate) {
            return null;
          }

          return (
            <Card key={dm._id} variant="outlined" sx={{ boxShadow: 2 }}>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box display="flex" alignItems="center">
                    <Checkbox
                      checked={selectedDecisionMakers.includes(dm._id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedDecisionMakers([...selectedDecisionMakers, dm._id]);
                        } else {
                          setSelectedDecisionMakers(selectedDecisionMakers.filter(id => id !== dm._id));
                        }
                      }}
                    />
                    <Avatar src={candidate?.dp} alt={candidate?.name || 'Unknown'} sx={{ width: 50, height: 50, ml: 1 }} />
                    <Box ml={2}>
                      <Typography variant="subtitle1">{candidate?.name || 'Unknown'}</Typography>
                      <Typography variant="body2" color="textSecondary">{dm.Designation}</Typography>
                    </Box>
                  </Box>
                  {candidate?.linkedin && (
                    <LinkedInIcon color="primary" sx={{ cursor: 'pointer' }} onClick={() => window.open(candidate.linkedin, '_blank')} />
                  )}
                </Box>

                <Divider sx={{ my: 1 }} />

                <Typography variant="body2"> {company?.Name || 'Unknown'}</Typography>
                <Typography variant="body2">{new Date(dm.createdAt).toLocaleDateString()}</Typography>
                <Typography variant="body2">{dm.status}</Typography>
                {user.role === 'admin' || user.role === 'recruiter' ? (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    <strong>Email:</strong> {dm.WorkEmail}{' '}
                    {dm.validationStatus === 'Valid' ? (
                      <span style={{ color: 'green' }}>✔</span>
                    ) : dm.WorkEmail !== '' ? (
                      <span style={{ color: 'red' }}>✘ {dm.validationStatus}</span>
                    ) : null}
                  </Typography>
                ) : null}
                {/* Email Status */}
                {([ "Followup Pending", "Closing Outreach Pending","Outreach Completed", "Response Received"].includes(status)) && (
                                        <Typography variant="body2" sx={{ mt: 1 }}>
                                            {
                                                
                                               emails.filter(e => e.to === dm.WorkEmail).map((e, index) => (
                                                <>
                                                <br /><Link
                                                    key={index}
                                                    onClick={() => setEmail(e)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                 {e.name ? e.name + " - " :"" }{e.status}
                                                </Link>
                                                </>
                                            ))
                                        }                                    
                                        </Typography> )}
                {/* Actions */}
                <Box mt={2} display="flex" flexDirection="column" gap={1}>
                  {['Initial Outreach Pending', 'Followup Pending', 'Closing Outreach Pending'].includes(status) && (
                    <>
                      {(status === 'Initial Outreach Pending' || new Date(dm.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))) && (
                        <Button variant="contained" onClick={() => handlePreview(template, dm._id)}>
                          Send Email
                        </Button>
                      )}
                      {status !== 'Initial Outreach Pending' && candidate?._id && (
                        <Button variant="outlined" onClick={() => handleStatus(candidate._id, 'Response Received')}>
                          Mark Response Received
                        </Button>
                      )}
                      {status === 'Initial Outreach Pending' && candidate?._id && (
                        <Button variant="contained" color="error" onClick={() => handleStatus(candidate._id, 'Rejected')}>
                          Reject Lead
                        </Button>
                      )}
                    </>
                  )}
                  {status === 'Outreach Completed' && candidate?._id && (
                    <Button variant="contained" color="success" onClick={() => handleStatus(candidate._id, 'Response Received')}>
                      Response Received?
                    </Button>
                  )}
                  {dm.status === 'Response Received' && candidate?._id && (
                    <>
                      <Button variant="contained" color="success" onClick={() => handleStatus(candidate._id, 'Positive Outcome')}>
                        Positive Outcome
                      </Button>
                      <Button variant="contained" color="warning" onClick={() => handleStatus(candidate._id, 'Negative Outcome')}>
                        Negative Outcome
                      </Button>
                    </>
                  )}
                  {status === 'Rejected' && candidate?._id && (
                    <Button variant="contained" color="success" onClick={() => handleStatus(candidate._id, 'Initial Outreach Pending')}>
                      Send for Outreach
                    </Button>
                  )}
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    );
  }

  // Default Table view (unchanged for large screens)
  return (
    <TableContainer component={Paper}>
                            {(selectedDecisionMakers.length > 0 && template !=='') && (
                                <Box display="flex" justifyContent="center" alignItems="center" mt={2} mb={2} 
                                sx={{
                                padding: 2,
                                border: "1px solid #ececec",
                                borderRadius: "8px",
                                fontSize: "0.9rem",
                                lineHeight: 1.5,
                                overflowWrap: "break-word",
                                whiteSpace: "pre-wrap",
                                }}>
                                    {selectedDecisionMakers.length} Decision Makers selected. <Button variant="contained" onClick={() => handlePreview(template)}>Send {templates.find(t => t._id === template)?.name}</Button>
                                </Box>
                            )}
    
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <Checkbox
                                                    checked={
                                                        [ "Followup Pending", "Closing Outreach Pending"].includes(status) ?                                                                                                        
                                                        (selectedDecisionMakers.length === decisionMakers.filter(dm => filterstatus[status].includes(dm.status) && new Date(dm.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))).length && decisionMakers.filter(dm => filterstatus[status].includes(dm.status) && new Date(dm.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))).length > 0)
                                                        : (selectedDecisionMakers.length === decisionMakers.filter(dm => filterstatus[status].includes(dm.status)).length && decisionMakers.filter(dm => filterstatus[status].includes(dm.status)).length > 0) 
                                                    }
                                                    onChange={(e) => {
                                            if (e.target.checked && [ "Followup Pending", "Closing Outreach Pending"].includes(status) ) {
                                                setSelectedDecisionMakers(decisionMakers.filter(dm => filterstatus[status].includes(dm.status) && new Date(dm.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))).map(dm => dm._id ));
                                            } 
                                            else if (e.target.checked) {
                                                
                                                    setSelectedDecisionMakers(decisionMakers.filter(dm => filterstatus[status].includes(dm.status)).map(dm => dm._id ));
                                                }
                                                else {
                                                setSelectedDecisionMakers([]);
                                            }
                                        }}
                                    />
                                </TableCell>
                                <TableCell>Added on</TableCell>
                                <TableCell><span
                                            style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                            onClick={() => {
                                                const selectElement = document.getElementById('company-select');
                                                if (selectElement) {
                                                    selectElement.style.display = selectElement.style.display === 'none' ? 'block' : 'none';
                                                }
                                                const companySelect = document.getElementById('selected-company-chip');
                                                if (companySelect) {
                                                    companySelect.style.display = companySelect.style.display === 'none' ? 'block' : 'none';
                                                }
                                            }}
                                            >
                                            Company
                                            {selectedCompany && selectedCompany.length > 0 && (
                                              <Box component="span" ml={1} sx={{ fontSize: '0.875rem', color: 'primary.main' }} id="selected-company-chip">
                                              <Chip
                                                label={Project.TargetCompany.find(tc => tc.Organization === selectedCompany)?.Name}
                                                onDelete={() => setSelectedCompany(null)}
                                                size="small"
                                                color="primary"
                                                variant="outlined"
                                              />
                                              </Box>
                                            )}
                                            </span>
                                            <div id="company-select" style={{ display: 'none' }}>
                                            <Select
                                              isMulti
                                              value={selectedCompany}
                                              onChange={(event) => setSelectedCompany(event.target.value)}
                                              displayEmpty
                                              inputProps={{ 'aria-label': 'Select Company' }}
                                              style={{ width: '100%' }}
                                            >
                                              <MenuItem value="">
                                              <em>All Companies</em>
                                              </MenuItem>
                                              {Project.TargetCompany.map((company) => (
                                              <MenuItem key={company.Organization} value={company.Organization}>
                                                {company.Name}
                                              </MenuItem>
                                              ))}
                                            </Select>
                                            </div>
                                            </TableCell>
                                          <TableCell>Name</TableCell>
                                          {(user.role === "admin" || user.role === "recruiter") && (
                                          <TableCell>Email</TableCell>)}
                                          <TableCell>Status</TableCell>
                                          {([ "Followup Pending", "Closing Outreach Pending"].includes(status)) && (
                                          <TableCell>Next Followup</TableCell>)}
                                          {([ "Followup Pending", "Closing Outreach Pending","Outreach Completed", "Response Received"].includes(status)) && (
                                          <TableCell>Email Status</TableCell>)}
                                          <TableCell>Action</TableCell>                            
                                        </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        { 
                                        decisionMakers.filter(dm => (filterstatus[status].includes(dm.status) && (selectedCompany===null|| selectedCompany?.length===0 || selectedCompany.includes(dm.TargetCompanyId)))).map(dm => dm._id).map((decisionMakerId) => {
                                const decisionMaker = decisionMakers.find(dm => dm._id === decisionMakerId);
                                if (!decisionMaker || !decisionMaker.candidateId) return null;
                                const company = Project.TargetCompany.find(tc => tc.Organization === decisionMaker.TargetCompanyId);
                                return (
                                    <TableRow key={decisionMaker._id}>
                                        <TableCell>
                                            <Checkbox
                                                checked={selectedDecisionMakers.includes(decisionMaker._id)}
                                                disabled={!(["Initial Outreach Pending"].includes(status) || (new Date(decisionMaker.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))))}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedDecisionMakers([...selectedDecisionMakers, decisionMaker._id]);
                                                    } else {
                                                        setSelectedDecisionMakers(selectedDecisionMakers.filter(id => id !== decisionMaker._id));
                                                    }
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>{new Date(decisionMaker.createdAt).toLocaleDateString()}</TableCell>
                                        <TableCell>
                                            <CompanyLogo companyName={company?.Name || ""} sx={{ width: '60px', height: '60px' }} />
                                            <br/>
                                            {company ? company.Name : 'Unknown'}
                                        </TableCell>                        <TableCell>
                        {decisionMaker.candidateId?.linkedin ? (
                            <Link href={decisionMaker.candidateId.linkedin} target="_blank" rel="noopener">
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                <Avatar
                                src= {decisionMaker.candidateId?.dp}
                                sx={{ width: 50, height: 50, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)' }}
                                />
                                <div style={{marginLeft: '10px'}}>
                                {decisionMaker.candidateId?.name || 'Unknown'}
                                <br/>{decisionMaker.Designation}
                                <LinkedInIcon />
                                </div>
                                </div>
                            </Link>
                        ) : (
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <Avatar
                                src= {decisionMaker.candidateId?.dp}
                                sx={{ width: 50, height: 50, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)' }}
                                />
                                <div style={{marginLeft: '10px'}}>
                                {decisionMaker.candidateId?.name || 'Unknown'}
                                <br/>{decisionMaker.Designation}
                                </div>
                            </div>
                        )}
                            {(user.role === "admin" || user.role === "recruiter") && (
                                            
                                            <a
                                                onClick={() => {
                                                    setSelectedDecisionMaker(decisionMaker);
                                                    setShowEditSidebar(true);
                                                }}
                                            >
                                                <EditIcon />
                                            </a>
                                       )}
                                       </TableCell>
                                                                               
                                            {(user.role === "admin" || user.role === "recruiter") && (
                                            <TableCell>                                          
                                       
                                                {decisionMaker.WorkEmail} 
                                                {(decisionMaker.validationStatus === "Valid") && (
                                                    <span style={{ color: 'green', fontWeight: 'bold' }}>✔</span>
                                                )}
                                                {(decisionMaker.validationStatus !== "Valid" && decisionMaker.WorkEmail!== "") && (
                                                    <>
                                                    <span style={{ color: 'red', fontWeight: 'bold' }}>✘</span>
                                                    {decisionMaker.validationStatus}</>
                                                )}
                                            </TableCell>)}
                                        <TableCell>
                                            {decisionMaker.status === "Initial Outreach" ? "Followup Pending" : 
                                             decisionMaker.status === "Follow up" ? "Closing Outreach Pending" : 
                                             decisionMaker.status}
                                        </TableCell>  
                                        {(() => {
                                            let Option = "Approved";
                                            if (Project.TargetCompany.find(tc => tc.Organization === decisionMaker.TargetCompanyId)?.Status === "Share with Client") {
                                                Option = "Initial Outreach Pending";
                                            }
                                            return ["Suggested"].includes(status) && decisionMaker.candidateId?._id && (
                                                <TableCell>                                                
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => ChangeStatus(decisionMaker.candidateId._id, Option)}
                                                    >                                             
                                                       {Option} {(decisionMaker.validationStatus === "Valid") && (" Without Email")}
                                                    </Button>
                                                </TableCell>
                                            );
                                        })()}
                                        {([ "Followup Pending", "Closing Outreach Pending"].includes(status)) && (
                                        <TableCell>
                                            {(() => {
                                                const daysDifference = Math.floor((new Date() - new Date(decisionMaker.updatedAt)) / (1000 * 60 * 60 * 24)) - DueDays;
                                                if (daysDifference > 0) {
                                                    return `${daysDifference} Days overdue`;
                                                } else if (daysDifference < 0) {
                                                    return `After ${Math.abs(daysDifference)} Days`;
                                                } else if (daysDifference === 0) {
                                                    return "Today";
                                                }
                                            })()}
                                        </TableCell>
                                        )}
                                    
                                    {([ "Followup Pending", "Closing Outreach Pending","Outreach Completed", "Response Received"].includes(status)) && (
                                        <TableCell>
                                            {
                                                
                                               emails.filter(e => e.to === decisionMaker.WorkEmail).map((e, index) => (
                                                <>
                                                <br /><Link
                                                    key={index}
                                                    onClick={() => setEmail(e)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                 {e.name ? e.name + " - " :"" }{e.status}
                                                </Link>
                                                </>
                                            ))
                                        }                                    
                                        </TableCell> )}
                                        <TableCell align="center">
                                            {["Initial Outreach Pending", "Followup Pending", "Closing Outreach Pending"].includes(status) && (
                                                <>
                                                { (["Initial Outreach Pending"].includes(status) || (new Date(decisionMaker.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))))&& (
                                                    <Button 
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        sx={{ width: '80%' }}
                                                        onClick={() => {
                                                            handlePreview(template,decisionMaker._id)
                                                        }}
                                                    >
                                                        Send Email
                                                    </Button> )}
                                                    {status !== "Initial Outreach Pending" && decisionMaker.candidateId?._id && (
                                                        <Button 
                                                            variant="outlined"
                                                            color="primary"
                                                            sx={{ width: '80%' }}
                                                            size="small"
                                                            onClick={() => handleStatus(decisionMaker.candidateId._id, "Response Received")}
                                                        >Mark Response Received?
                                                        </Button>
                                                    )}
                                                    {status === "Initial Outreach Pending" && decisionMaker.candidateId?._id && (
                                                        <Button 
                                                            variant="contained"
                                                            color="error"
                                                            sx={{ width: '80%' }}
                                                            size="small"
                                                            onClick={() => handleStatus(decisionMaker.candidateId._id, "Rejected")}
                                                        >
                                                            Reject Lead
                                                        </Button>
                                                    )}
                                                </>
                                            )}
                                            {status === "Outreach Completed" && decisionMaker.candidateId?._id && (
                                                <Button 
                                                    variant="contained"
                                                    color="success"
                                                    sx={{ width: '80%' }}
                                                    size="small"
                                                    onClick={() => handleStatus(decisionMaker.candidateId._id, "Response Received")}
                                                >
                                                    Response Received?
                                                </Button>
                                            )}
                                            {decisionMaker.status === "Response Received" && decisionMaker.candidateId?._id && (
                                                <>
                                                    <Button 
                                                        variant="contained"
                                                        color="success"
                                                        sx={{ width: '80%' }}
                                                        size="small"
                                                        onClick={() => handleStatus(decisionMaker.candidateId._id, "Positive Outcome")}
                                                    >
                                                        Positive Outcome
                                                    </Button>
                                                    <Button 
                                                        variant="contained"
                                                        color="warning"
                                                        sx={{ width: '80%' }}
                                                        size="small"
                                                        onClick={() => handleStatus(decisionMaker.candidateId._id, "Negative Outcome")}
                                                    >
                                                        Negative Outcome
                                                    </Button>
                                                </>
                                            )}
                                            {status === "Rejected" && decisionMaker.candidateId?._id && (
                                                <Button 
                                                    variant="contained"
                                                    color="success"
                                                    sx={{ width: '80%' }}
                                                    size="small"
                                                    onClick={() => handleStatus(decisionMaker.candidateId._id, "Initial Outreach Pending")}
                                                >
                                                    Send for Outreach
                                                </Button>
                                            )}
                                        </TableCell>
                                                            
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
  );
};

export default ResponsiveDecisionMakerList;
